export const DEFAULT_FILTERS = {
  tipos: [],
  estado: null,
  soloPendientesDeAplicar: false,
  fechaInicio: null,
  fechaFin: null,
  ordenarDatos: "DESC",
  resumenesConDetalles: null,
};
